export const getSidebarItemClassName = (props: { isActive: boolean; isPending?: boolean }) => {
	const inActiveClasses = "hover:bg-tertiary-hover text-tertiary border-l-4 border-transparent";
	const activeClasses = "bg-tertiary-hover hover:tertiary-hover text-white border-l-4 border-white";

	if (typeof props !== "object") {
		return inActiveClasses;
	}

	return props?.isActive ? activeClasses : inActiveClasses;
};
